import React from 'react';
import man1 from '../../assets/img/logo-icon.webp';
import bgImg from '../../assets/img/map_faq.webp';
import FaqAccordion from '../FaqAccordion';

function Faq() {
    return (
        <section className="faq-section">
            <div className="container">
                <div className="row">
                    <div className="col-xl-6 col-12">
                        <div className="content-block">
                            <p>Get Answers</p>
                            <h1>Get every single answers from here.</h1>
                            <div className="bg-img">
                                <img src={bgImg} alt="" />
                                <div
                                    className="man bg-cover man-1"
                                    style={{
                                        backgroundImage: `url(${man1})`,
                                    }}
                                />
                                <div
                                    className="man bg-cover man-2"
                                    style={{
                                        backgroundImage: `url(${man1})`,
                                    }}
                                />
                                <div
                                    className="man bg-cover man-3"
                                    style={{
                                        backgroundImage: `url(${man1})`,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-12 mt-4 mt-xl-0">
                        <div className="faq-content">
                            <FaqAccordion
                                question="What types of heavy equipment parts do you supply?"
                                answer="KJD supplies a wide range of heavy equipment components including engine parts, undercarriage systems (track chains, rollers, sprockets), turbochargers, filtration systems, seals, hydraulic hose couplings, and bucket teeth & attachments."
                            />
                            <FaqAccordion
                                question="Are you an authorized dealer for any brands?"
                                answer="Yes. CV. Kalimantan Jaya Diesel is an Authorised Dealer of Garrett Turbochargers. We also carry parts from other globally recognized brands such as Komatsu, CAT, Hitachi, Holset, BorgWarner, Fleetguard, Donaldson, and more."
                            />
                            <FaqAccordion
                                question="Do you supply both genuine and replacement parts?"
                                answer="Yes. We offer both genuine OEM parts and quality aftermarket alternatives manufactured in Japan, the U.S.A., Brazil, Korea, and China — ensuring options that fit every budget without compromising reliability."
                            />
                            <FaqAccordion
                                question="Which heavy machinery brands do your parts fit?"
                                answer="Our parts are compatible with major OEMs including Komatsu, Caterpillar (CAT), Hitachi, Kobelco, Sany, Doosan, Isuzu, and Cummins engines, among others."
                            />
                            <FaqAccordion
                                question="How many branches does KJD have and where are they located?"
                                answer="KJD currently operates 5 branches: Banjarmasin (Main Branch, South Kalimantan), Samarinda (East Kalimantan), Kendari (Southeast Sulawesi), Muara Enim (South Sumatera), and Jakarta (DKI Jakarta)."
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Faq;
